module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-popup-black"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "border"
  }, [_c('div', {
    staticClass: "pop_up"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.eventBybtnCrissCross
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.text))])]), _vm._v(" "), _vm._t("content"), _vm._v(" "), _c('div', {
    staticClass: "buttons-btm"
  }, [(_vm.isShowBtnSecondary) ? _c('LkButton', {
    attrs: {
      "isSecondary": true
    },
    on: {
      "onClick": _vm.eventBybtnSecondary
    }
  }, [_vm._v("\n          " + _vm._s(_vm.textBtnSecondary) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('LkButton', {
    on: {
      "onClick": _vm.eventBybtnPrimary
    }
  }, [_vm._v("\n          " + _vm._s(_vm.textBtnPrimary) + "\n        ")])], 1)], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a32b232e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop-ups/modal-popup-black.vue
// module id = 433
// module chunks = 1